/**
 * Confirmação de abandono do registro de refeição. O que já foi marcado fica
 * salvo; a sessão é marcada como abandonada.
 */
interface AbandonConfirmProps {
  onCancel: () => void;
  onConfirm: () => void;
  loading: boolean;
}

export function AbandonConfirm({ onCancel, onConfirm, loading }: AbandonConfirmProps) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="abandon-diet-title"
      className="fixed inset-0 z-50 flex items-end justify-center bg-black/60 p-4 backdrop-blur-sm sm:items-center"
    >
      <div className="animate-fade-in w-full max-w-sm rounded-2xl border border-border-subtle bg-surface/95 p-5 backdrop-blur-xl">
        <h2 id="abandon-diet-title" className="font-display text-lg text-ink">
          Abandonar registro?
        </h2>
        <p className="mt-2 text-sm text-muted">
          O que você já marcou fica salvo no histórico, mas a sessão é marcada como abandonada. Você
          pode iniciar um novo registro quando quiser.
        </p>
        <div className="mt-5 flex items-center gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="flex-1 rounded-xl border border-border-subtle bg-elevated px-3 py-2.5 text-sm font-medium text-ink transition-colors hover:border-border-strong hover:bg-surface-hover disabled:opacity-50"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className="flex-1 rounded-xl bg-danger/85 px-3 py-2.5 text-sm font-medium text-ink transition-opacity hover:opacity-90 disabled:opacity-50"
          >
            {loading ? "Abandonando…" : "Abandonar"}
          </button>
        </div>
      </div>
    </div>
  );
}
